import { createShopifyUrl } from "@/utils/createShopifyUrl"

export const apiUrl = createShopifyUrl(`/api/2025-10/graphql.json`)
